import React from 'react';


const admHOC = (InnerComponent) => class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentWillMount() {
      this.setState({
        formValues: {...this.props.defaultFormValue},
        formFieldValidity: {...this.props.defaultFieldValidity},
      })
    }

   componentWillReceiveProps(nextProps) {
     if(nextProps.selectedDataObj){
       this.setState({
         formValues: nextProps.selectedDataObj,
       })
     } else if (nextProps.keyEditable) {
       const timestamp = Date.now();
       this.setState({
         formValues: {...this.props.defaultFormValue, key: `name-${timestamp}`}
       })
     } else {
       this.setState({
         formValues: {...this.props.defaultFormValue},
       })
     }
   }

  checkAllFieldsValid = () => {
    const inputs = document.getElementsByTagName('input');
    const inputList = Array.prototype.slice.call(inputs);
    const validityArr = inputList.map(el => {
      return el.checkValidity();
    })
    return !validityArr.includes(false);
  };

  handleSubmit = (endpoint, e, fanoutObjArr) => {
    e.preventDefault();
    this.setState({
      ...this.state,
      submitAttempted: true,
      formFieldValidity: {
        ...this.state.formFieldValidity,
        _form: this.checkAllFieldsValid()}
    })
    if (fanoutObjArr && Array.isArray(fanoutObjArr)) {
      fanoutObjArr.forEach(elem => this.props.fanoutData(elem, 'update', e));
    }
    this.props.updateData(this.state.formValues, endpoint, e)
  };

  confirmDeletion = (endpoint, e, relativesArr, fanoutObjArr) => {
    // I dedicate this confirm function to Filippo Angelini. Uncool is cool if faster.
    // eslint-disable-next-line no-restricted-globals
    const r = confirm('Are you sure you want to delete?');

    if (r === true) {
      // delete the actual data and remove it from it's referrals,
      this.props.deleteData(this.state.formValues, endpoint, e);

    if (relativesArr && Array.isArray(relativesArr));
      relativesArr.forEach(elem => this.props.unpublishRelatives(elem, this.state.formValues.key));

    if (fanoutObjArr && Array.isArray(fanoutObjArr));
      fanoutObjArr.forEach(elem => this.props.fanoutData(elem, 'delete', e));

    } else {
      console.error('User cancelled the deletion');
      e.preventDefault();
    }
  };

  handleReset = (e) => {
    e.preventDefault();
    this.props.setKeyEditable(false);
    this.setState({
      formValues: {...this.props.defaultFormValue},
      formFieldValidity: {...this.props.defaultFieldValidity},
     });
  };

  handleChange = (e, { name, value, checked }) => {
    //required to set default for dropdowns which are not having validity API, TODO: review!
    const fieldValidity = (e.target.validity) ? e.target.validity.valid : true
    // if statement to cater for checkboxes:
    if (value === undefined)
    value = checked;

    if (e.target.type === 'number')
    value = parseInt(value,10);

    this.setState({
      formValues: {
        ...this.state.formValues,
        [name]: value
      },
      formFieldValidity: {
        ...this.state.formFieldValidity,
        [name]: fieldValidity
      }
    })
  };

  render() {
    return (
      <InnerComponent
        {...this.props}
        {...this.state}
        handleSubmit={this.handleSubmit}
        confirmDeletion={this.confirmDeletion}
        handleChange={this.handleChange}
        handleReset={this.handleReset}
        />
    );
  }
}

export default admHOC;



// WEBPACK FOOTER //
// ./src/components/forms/admHOC.js